import request from '../../../api/request';

import {
  AgreedPaymentDetail,
  AgreedPaymentRow,
  AgreedPaymentsFilters,
} from './types';

const BASE = '/maintainers-portal/financial-portal/agreed-payments';

interface PaginationResponse<T> {
  data: T[];
  total: number;
  total_pages: number;
}

export function listAgreedPayments(
  filters: AgreedPaymentsFilters & { page: number; items_per_page: number },
) {
  return request<PaginationResponse<AgreedPaymentRow>>(BASE, {
    method: 'get',
    params: filters,
  });
}

export function listAgreedPaymentsByStudent(
  studentId: number,
  filters: AgreedPaymentsFilters & { page: number; items_per_page: number },
) {
  return request<PaginationResponse<AgreedPaymentRow>>(
    `${BASE}/students/${studentId}`,
    { method: 'get', params: filters },
  );
}

export function getAgreedPaymentDetail(debtId: string) {
  return request<AgreedPaymentDetail>(`${BASE}/${debtId}/detail`, {
    method: 'get',
  });
}

export function downloadAgreedPayments(filters: AgreedPaymentsFilters) {
  return request(`${BASE}/download`, {
    method: 'get',
    params: filters,
    responseType: 'blob',
  });
}

export function downloadAgreedPaymentsByStudent(
  studentId: number,
  filters: AgreedPaymentsFilters,
) {
  return request(`${BASE}/students/${studentId}/download`, {
    method: 'get',
    params: filters,
    responseType: 'blob',
  });
}
